import * as types from "./actionTypes";

export const get = () => {
    return {
        type: types.GET_CURRENCIES_REQUEST
    };
};

export const getSuccess = data => {
    return {
        type: types.GET_CURRENCIES_SUCCESS,
        payLoad: data.data
    };
};
export const getFailure = () => {
    return {
        type: types.GET_CURRENCIES_FAILURE
    };
};
